import { createFileRoute } from "@tanstack/react-router";
import WebinarsPage from "@/modules/resources/pages/webinars";

export const Route = createFileRoute(
  "/(auth)/_headed/resources/_layout/webinars"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <WebinarsPage />;
}
